import {
	ADMINALLOCATEDMODULE_SUCCESS,
	ADMINALLOCATEDMODULE_FAILED,
	RESET_ADMINALLOCATEDMODULE,
	LOADING_ADMINALLOCATEDMODULE,
	NETWORK_ERROR_ADMINALLOCATEDMODULE
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminAllocatedModule = () => {
	return { type: RESET_ADMINALLOCATEDMODULE };
};

const AdminAllocatedModule = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINALLOCATEDMODULE });
	await adminServices
		.post("getAllocatedModuleList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(AdminAllocatedModulesuccess(res.data));
					break;
				default:
					dispatch(AdminAllocatedModuleFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({ type: NETWORK_ERROR_ADMINALLOCATEDMODULE, payload: err });
		});
};
function AdminAllocatedModulesuccess(data) {
	return {
		type: ADMINALLOCATEDMODULE_SUCCESS,
		payload: data
	};
}
function AdminAllocatedModuleFailed(data) {
	return {
		type: ADMINALLOCATEDMODULE_FAILED,
		payload: data
	};
}

export { resetAdminAllocatedModule, AdminAllocatedModule };
